import {
  TURNOVER_EDIT, TURNOVER_EDIT_FAILURE, TURNOVER_EDIT_SUCCESS, TURNOVER_UPDATE, TURNOVER_UPDATE_FAILURE, TURNOVER_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    turnover: null
  },
  getters: {
    turnover: state => {
      return state.turnover
    }
  },
  actions: {
    [TURNOVER_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = data.callback
      }
      var url = '/master/turnover_types/' + params.id
      dispatch('apiGet', {url: url, data: {id: params.id}, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(TURNOVER_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(TURNOVER_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [TURNOVER_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/turnover_types/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(TURNOVER_UPDATE_FAILURE, res.data)
            } else {
              commit(TURNOVER_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [TURNOVER_EDIT_FAILURE] (state, data) {
      console.log('TURNOVER_EDIT_FAILURE')
    },
    [TURNOVER_EDIT_SUCCESS] (state, data) {
      console.log('TURNOVER_EDIT_SUCCESS')
      state.turnover = data
      if (data.callback) {
        data.callback()
      }
    },
    [TURNOVER_UPDATE_FAILURE] (state, data) {
      console.log('TURNOVER_UPDATE_FAILURE')
    },
    [TURNOVER_UPDATE_SUCCESS] (state, data) {
      console.log('TURNOVER_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/turnover-edit.js